import React from 'react';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { Project, ProjectPriority } from '../../../app/entities';
import { UrgentPriorityIcon } from '../../../components/icons/urgent-priority';
import { TaskPropertyButton } from '../../tasks/components/task-property.button';

import styles from './priority-selector.module.scss';
type PrioritySelectorProps = {
  onChange?: (newStatus: ProjectPriority) => void;
  priority?: ProjectPriority;
  isViewOnly?: boolean;
  withTitle?: boolean;
  className?: string;

  trigger?: React.ReactElement;
};

export const PrioritySelector: React.FC<PrioritySelectorProps> = ({
  onChange,
  priority = ProjectPriority.NO_PRIORITY,
  isViewOnly,
  withTitle,
  className,
  trigger,
}) => {
  if (isViewOnly) {
    return trigger ? (
      trigger
    ) : (
      <TaskPropertyButton
        icon={<PriorityIcon priority={priority} />}
        label={withTitle ? Project.PriorityMapper[priority].title : ''}
        isActive={!!priority}
        isDisabled={isViewOnly}
      />
    );
  }

  return (
    <DropdownMenu
      modal
      items={Project.PriorityArray.map(([key, { title }]) => ({
        title,
        onSelect: () => onChange?.(Number(key) as ProjectPriority),
        icon: <PriorityIcon priority={Number(key) as ProjectPriority} />,
      }))}
      align="start"
      className={className}
      trigger={
        <div>
          {trigger ? (
            trigger
          ) : (
            <TaskPropertyButton
              icon={<PriorityIcon priority={priority} />}
              label={withTitle ? Project.PriorityMapper[priority].title : ''}
              isActive={!!priority}
            />
          )}
        </div>
      }
      disabled={isViewOnly}
    />
  );
};

export const PriorityIcon = ({ priority }: { priority: ProjectPriority }) => (
  <div className={styles['icon']}>
    {priority !== ProjectPriority.URGENT ? (
      <>
        <span data-priority={`${priority}`} />
        <span data-priority={`${priority}`} />
        <span data-priority={`${priority}`} />
      </>
    ) : (
      <UrgentPriorityIcon />
    )}
  </div>
);
